import { Outdent } from "lucide-react";
import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const DashboardPage = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname.endsWith(path);
  const [viewMode, setViewMode] = useState("Weekly"); // Can be "Daily", "Weekly", or "Monthly"

  return (
    <>
      <div className="bg-white p-4 rounded-lg w-full mx-auto">
        <div className="bg-[#0D99FF] text-white p-5 rounded-xl mb-5 flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
          <div className="flex-1 text-center md:text-left">
            <h1 className="m-0 text-xl font-medium">
              Welcome to Your Learning Adventure
            </h1>
            <p className="mt-1 text-sm opacity-90">
              Let's discover where you are on your learning journey
            </p>
          </div>
          <div className="flex items-center justify-center">
            {/* <div className="bg-opacity-20 rounded-full flex items-center justify-center">
              <img
                src="/assets/images/robot.png"
                alt="Robot Icon"
                className="w-16 h-16 object-contain"
              />
            </div> */}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4 sm:gap-0">
          <div className="flex flex-wrap justify-center sm:justify-start gap-4">
            {/* Tab Links */}
            <Link
              to=""
              className={`relative px-2 py-2 text-base cursor-pointer ${
                isActive("dashboard") ? "font-medium" : "text-gray-600"
              }`}
              style={isActive("dashboard") ? { color: "#0D99FF" } : {}}
              onMouseEnter={(e) => {
                if (!isActive("dashboard")) {
                  e.currentTarget.style.color = "#0D99FF";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive("dashboard")) {
                  e.currentTarget.style.color = "#6B7280";
                }
              }}
            >
              Strength Areas
              {isActive("dashboard") && (
                <span
                  className="absolute bottom-0 left-0 w-full h-0.5"
                  style={{ backgroundColor: "#0D99FF" }}
                />
              )}
            </Link>
            <Link
              to="growth"
              className={`relative px-2 py-2 text-base cursor-pointer ${
                isActive("growth") ? "font-medium" : "text-gray-600"
              }`}
              style={isActive("growth") ? { color: "#0D99FF" } : {}}
              onMouseEnter={(e) => {
                if (!isActive("growth")) {
                  e.currentTarget.style.color = "#0D99FF";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive("growth")) {
                  e.currentTarget.style.color = "#6B7280";
                }
              }}
            >
              Growth Areas
              {isActive("growth") && (
                <span
                  className="absolute bottom-0 left-0 w-full h-0.5"
                  style={{ backgroundColor: "#0D99FF" }}
                />
              )}
            </Link>
            <Link
              to="progress"
              className={`relative px-2 py-2 text-base cursor-pointer ${
                isActive("progress") ? "font-medium" : "text-gray-600"
              }`}
              style={isActive("progress") ? { color: "#0D99FF" } : {}}
              onMouseEnter={(e) => {
                if (!isActive("progress")) {
                  e.currentTarget.style.color = "#0D99FF";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive("progress")) {
                  e.currentTarget.style.color = "#6B7280";
                }
              }}
            >
              Overall Progress
              {isActive("progress") && (
                <span
                  className="absolute bottom-0 left-0 w-full h-0.5"
                  style={{ backgroundColor: "#0D99FF" }}
                />
              )}
            </Link>
            {/* <Link
              to="goals"
              className={`relative px-2 py-2 text-base cursor-pointer
                ${
                  isActive("goals")
                    ? "text-indigo-700 font-medium after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-indigo-700"
                    : "text-gray-600"
                }
              `}
            >
              Goals
            </Link> */}
            {/* <Link
              to="challenges"
              className={`relative px-2 py-2 text-base cursor-pointer
                ${
                  isActive("challenges")
                    ? "text-indigo-700 font-medium after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-indigo-700"
                    : "text-gray-600"
                }
              `}
            >
              Challenges
            </Link> */}
          </div>

          <div className="relative w-full sm:w-auto">
            <select
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value)}
              className="block appearance-none w-full sm:w-auto bg-white border border-gray-300 text-gray-800 py-2 px-4 pr-8 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            >
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </select>
            {/* Custom arrow */}
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <Outlet context={{ period: viewMode.toLowerCase() }} />
      </div>
    </>
  );
};

export default DashboardPage;
